import loginView from '../components/login.vue'
import homeView from '../components/home.vue'

export default [
  {
    path: '/',
    redirect: '/home',
    meta: {
      requiresLoggedIn: true
    }
  },
  {
    path: '/home',
    component: homeView,
    meta: {
      requiresLoggedIn: true
    }
  },
  {
    name: 'login',
    path: '/login',
    component: loginView,
    meta: {
      bodyClass: 'login-page'
    }
  }
]
